import React from "react";

import banner from "../../images/home/banner.webp";
import image1 from "../../images/home/energy2.webp";
import image2 from "../../images/home/financial1.webp";
import image3 from "../../images/home/insurance4.webp";
import image4 from "../../images/home/healthcare1.webp";
import image5 from "../../images/home/retail4.webp";
import image6 from "../../images/home/manufacturing2.webp";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  return (
    <>
      <section
        className="home_banner black_fade"
        style={{ background: `url(${banner}) center center / cover no-repeat` }}
      >
        <div className="container">
          <div className="banner_content text-center text-white">
            <h3>EXPLORE, DESIGN, CREATE.</h3>
            <h1>CYLON TECHNOLOGIES</h1>

            <a
              className="btn_custom blue_btn"
              onClick={() => {
                navigate("/our-story");
              }}
            >
              Our Story
            </a>
          </div>
        </div>
      </section>

      <section className="sec-padd">
        <div className="container">
          <div className="row g-md-5 g-4 align-items-center">
            <div className="col-md-7">
              <h2 className="heading_c">Energy & Utilities</h2>
              <p>
                Evolution is hitting the Retail industry, like never before.
                Customers today are vastly educated and more connected,
                globally. They need versatile shopping, customized
                administration and instant satisfaction. These progressions are
                offering ascent to a large group of developments around
                retailing, versatile applications, client information mining,
                responsive supply chains and other technologies.
              </p>
              <div className="btn_spacet">
                <a
                  onClick={() => {
                    navigate("/energy-utilities");
                  }}
                  className="btn_small outline_blue"
                >
                  {" "}
                  Learn More{" "}
                </a>
              </div>
            </div>
            <div className="col-md-5">
              <img src={image1} className="rounded-2" alt="image" />
            </div>
          </div>
        </div>
      </section>

      <section
        className="inner_banner white_inner black_fade"
        style={{ background: `url(${image2}) center center / cover no-repeat` }}
      >
        <div className="container">
          <div className="ms-auto col-md-7">
            <div className="content_inner text-end text-white">
              <h2>Financial Services</h2>
              <p>
                In an exceptionally managed and focused business sector, banks
                require each point of interest to surpass client desires and
                differentiate. It is not sufficient any more to offer
                straightforward and computerized Banking administrations.
              </p>
              <p>
                Keeping in mind the end goal to manufacture unwaveringness and
                drive benefit, banks should offer a constant intelligent Banking
                environment. To accomplish this, banks need to build their
                business readiness by foreseeing client needs and offer a
                connecting with client experience.
              </p>

              <div className="btn_spacet text-end">
                <a
                  onClick={() => {
                    navigate("/financial-services");
                  }}
                  className="btn_small outline_white"
                >
                  {" "}
                  Learn More{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sec-padd">
        <div className="container">
          <div className="row g-md-5 g-4 align-items-center">
            <div className="col-md-7">
              <h2 className="heading_c">Insurance</h2>
              <p>
                The Insurance industry confronts major changes on a few fronts,
                like the markets are changing, client propensities are advancing
                on account of the accessibility of information, there is an
                interest for better administration, administrative instability
                prevails, the online and versatile situations are assuming a
                discriminating part later on of business and rivalry from
                non-customary players is developing. The business is at the apex
                of real change, with innovation along with technology assuming a
                bigger part in development.
              </p>

              <div className="btn_spacet">
                <a
                  onClick={() => {
                    navigate("/insurance");
                  }}
                  className="btn_small outline_blue"
                >
                  {" "}
                  Learn More{" "}
                </a>
              </div>
            </div>
            <div className="col-md-5">
              <img src={image3} className="rounded-2" alt="image" />
            </div>
          </div>
        </div>
      </section>
      <section
        className="inner_banner white_inner black_fade"
        style={{ background: `url(${image4}) center center / cover no-repeat` }}
      >
        <div className="container">
          <div className="ms-auto col-md-7">
            <div className="content_inner text-end text-white">
              <h2>Healthcare</h2>
              <p>
                Concentration on responsibility and quality results have
                prompted basic changes in the Healthcare industry. All active
                participants of this sector must re-evaluate their solution
                framework and structure. Healthcare IT solutions need services
                more than anyone else due to critical expectations of the
                people. One must have a feasible restitution in place to deliver
                to client requirements. We help in improving customer experience
                with reduced costs and improve processes.
              </p>

              <div className="btn_spacet text-end">
                <a
                  onClick={() => {
                    navigate("/healthcare");
                  }}
                  className="btn_small outline_white"
                >
                  {" "}
                  Learn More{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="sec-padd">
        <div className="container">
          <div className="row g-md-5 g-4 align-items-center">
            <div className="col-md-7">
              <h2 className="heading_c">Retail</h2>
              <p>
                Evolution is hitting the Retail industry, like never before.
                Customers today are vastly educated and more connected,
                globally. They need versatile shopping, customized
                administration and instant satisfaction. These progressions are
                offering ascent to a large group of developments around
                retailing, versatile applications, client information mining,
                responsive supply chains and other technologies. The way to
                building up business sector center and position in the Retail
                industry is to turn into a user friendly destination. Today’s
                retailers confront an inexorably aggressive commercial center,
                where customer steadfastness is hard to win and much harder to
                secure. Rivalry from supercenters and accommodation stores is on
                an ascent.
              </p>
              <div className="btn_spacet">
                <a
                  onClick={() => {
                    navigate("/retail");
                  }}
                  className="btn_small outline_blue"
                >
                  {" "}
                  Learn More{" "}
                </a>
              </div>
            </div>
            <div className="col-md-5">
              <img src={image5} className="rounded-2" alt="image" />
            </div>
          </div>
        </div>
      </section>
      <section
        className="inner_banner white_inner black_fade"
        style={{ background: `url(${image6}) center center / cover no-repeat` }}
      >
        <div className="container">
          <div className="ms-auto col-md-7">
            <div className="content_inner text-end text-white">
              <h2>Manufacturing</h2>
              <p>
                Process manufacturers are required to ensure manufacturing
                consistency throughout the production cycle with intensive,
                multifaceted shop floor execution capabilities and as such this
                sector is heavily investing in Internet of Things and in other
                digital technologies. This digital transformation is helping
                them in optimizing their supply chain operations, in driving
                down the operating costs and an increase in their plant yield.
              </p>

              <div className="btn_spacet text-end">
                <a
                  onClick={() => {
                    navigate("/manufacturing");
                  }}
                  className="btn_small outline_white"
                >
                  {" "}
                  Learn More{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
